import { Component, inject } from "@angular/core";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { CRYPTO_TYPE, LEVERAGED_TOKEN_TYPE } from "@helpers/constants";
import { MarginTradingFacade } from "@modules/margin-trading/services/margin-trading.facade";
import { MarginTradingRemote } from "@modules/margin-trading/services/margin-trading.remote";
import { combineLatest, map, Observable } from "rxjs";
import { CustomModal } from "../../../core/components/base-modals";

@Component({
	templateUrl: "./tradable-you-own-modal.component.html",
	styleUrls: ["./tradable-you-own-modal.component.scss"],
	standalone: false
})
export class TradableYouOwnModalComponent extends CustomModal {
	private readonly marginTradingRemote: MarginTradingRemote = inject(MarginTradingRemote);
	private readonly marginTradingFacade: MarginTradingFacade = inject(MarginTradingFacade);

	public leverageType: string = LEVERAGED_TOKEN_TYPE;
	public cryptoType: string = CRYPTO_TYPE;

	// TODO: CFD CLEANUP, remove flag
	public cfdEnabled$: Observable<boolean> = this.launchDarklyService.isActive$(LD_FLAG.LEVERAGE_CFD);

	public isMarginTradingEligible$: Observable<boolean> = combineLatest({
		isMarginTradingEligible: this.marginTradingRemote.isMarginTradingEligible$(),
		isMarginTradingEnabled: this.marginTradingFacade.marginTradingEnabled$()
	}).pipe(
		map(({ isMarginTradingEligible, isMarginTradingEnabled }) => isMarginTradingEligible && isMarginTradingEnabled)
	);

	public constructor(private readonly launchDarklyService: LaunchDarklyService) {
		super();
	}
}
